import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  AssetAccountDataById,
  CREATE_ASSET_ACCOUNT_DATA,
  DELETE_ASSET_ACCOUNT_DATA,
  EDIT_ASSET_ACCOUNT_DATA,
  GrtPreferenceByFormKey,
  LOCK_ACCOUNT,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import "./AddAssetAccount.scss";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { IoSettingsOutline } from "react-icons/io5";
import { DefaultAssetAccountConfiguration } from "./AddAssetAccountConfig";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";

const AddAssetAccount = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const formRef = useRef({});
  const Form_Key = "Asset_Account";
  const { pushModal, popModal, getTopModal } = useModalContext();
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Asset_Account?.Selected_Row;
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [FormData, setFormdata] = useState({});
  const [openSetting, setOpenSetting] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: CreateAsset }] = useMutation(CREATE_ASSET_ACCOUNT_DATA);

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(AssetAccountDataById, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: EditAsset }] = useMutation(EDIT_ASSET_ACCOUNT_DATA);

  const [DeletingData, { loading: DelteAsset }] = useMutation(DELETE_ASSET_ACCOUNT_DATA);

  const [lockTheEntry, { loading: lockAssetAccountLoading }] = useMutation(LOCK_ACCOUNT);

  const [getDataByKey, { loading: userPreferenceLoading }] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const AssetAccountLoadingState =
    CreateAsset ||
    EditAsset ||
    DelteAsset ||
    lockAssetAccountLoading ||
    GetDataByIDLoader ||
    getFormFieldsLoading ||
    userPreferenceLoading;

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const getDefaultValues = async () => {
    try {
      const { data } = await getDataByKey({
        variables: {
          Form_Key,
        },
      });

      let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };

      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: { Account_Group: obj.accountgroups },
        },
      });
      obj.Account_Group = obj?.accountgroups?.Search_Value;
      obj.accountgroups = obj?.accountgroups?.Search_Value;
      setFormdata((prev) => ({
        ...prev,
        ...obj,
      }));
      updateValueForm(formRef, obj);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getFormSectionAndFields().then(() => {
      if (TypeOfPortal !== "Delete" && TypeOfPortal !== "Add") {
        GetDataByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let AssetAccountData = { ...data?.Account };
          dispatch({
            type: "SearchMasterData",
            payload: {
              Account_Group: { _id: AssetAccountData?.Account_Groups?._id },
            },
          });
          if (AssetAccountData?.customFieldData && typeof AssetAccountData.customFieldData === "object") {
            Object.entries(AssetAccountData.customFieldData).forEach(([key, value]) => {
              AssetAccountData[key] = value ?? ""; // Assign value or empty string if undefined/null
            });
          }
          if (AssetAccountData && AssetAccountData.Account_Groups) {
            AssetAccountData.Account_Group = AssetAccountData.Account_Groups.Account_Group;
          }
          delete AssetAccountData.customFieldData;
          setAllFieldsData(AssetAccountData);
          updateValueForm(formRef, AssetAccountData);
        });
      } else {
        getDefaultValues();
      }
    });
  }, [fielddata]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Asset_Account?.Selected_Rows);
  }, [fielddataRedux]);

  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let newFormData = FormData;

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, newFormData, selectedRows);

  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
    lockTheEntry,
  };

  useEffect(() => {
    if (inputFields && inputFields?.length > 0) {
      const fields = extractCustomFields(inputFields);
      setStoreCustomFields(fields);
    }
  }, [inputFields]);

  const submit = async (closeAction) => {
    let formData = processFormDataWithCustomFields(newFormData, storeCustomFields);
    formData.Account_Type = "Asset Account";
    formData.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
    delete formData.accountgroups;
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);

    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: () => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    popModal(Form_Key);
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={AssetAccountLoadingState}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => {
        Validate_handleSubmit(submit);
      }}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
              Validate_handleSubmit(SaveAndCloseForAdd);
            }
          : () => {
              Validate_handleSubmit(submit);
            }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={AssetAccountLoadingState}
    />
  );

  return (
    <>
      <div className="AssetAccountSection">
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " " + "Asset Account"}
          AdditionalContent={() => {
            return (
              <span onClick={HandleSettingClick} className="settingIcon">
                <IoSettingsOutline className="settingIcon" />
              </span>
            );
          }}
        >
          <>
            <div className="AssetAccountSection">
              {AssetAccountLoadingState && <div className="loader-line-div" />}
              <div className="formContainer">
                {inputFields && inputFields?.length > 0 ? (
                  inputFields.map((e) => (
                    <div className="FormSectionParent" key={e.id || e.name}>
                      {e?.name.startsWith("Parent") ? (
                        e.sections?.map((el) => (
                          <div key={el.name}>
                            <div className="sectionHeadings">{replaceUnderscore(el.name)}</div>
                            <div className="FormSection">
                              <FormInputSectionComponent
                                accountId=""
                                fielddata={allFieldsData}
                                inputfields={el.fields}
                                Type={el.name}
                                onErrorsChange={handleErrorsChange}
                                onhandleFormikChange={HanldeChangeonForm}
                                TypeOfPortal={TypeOfPortal}
                                formkey={Form_Key}
                                formRef={formRef}
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>
                          <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                          <div className="FormSection">
                            <FormInputSectionComponent
                              accountId=""
                              fielddata={allFieldsData}
                              inputfields={e.fields}
                              Type={e.name}
                              formkey={Form_Key}
                              onhandleFormikChange={HanldeChangeonForm}
                              formRef={formRef}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                  <p>No form fields available.</p>
                ) : null}
              </div>
              {openSetting && (
                <FormConfiguration
                  show={openSetting}
                  ParentClosingFunction={setOpenSetting}
                  config={DefaultAssetAccountConfiguration}
                  HanldeChangeonForm={HanldeChangeonForm}
                  formRef={formRef}
                  allFieldsData={allFieldsData}
                  getFormSectionAndFields={getFormSectionAndFields}
                  ToGetDefaultValues={() => {
                    getDefaultValues();
                  }}
                  formKey={Form_Key}
                  forFormValues={FormData}
                />
              )}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddAssetAccount;
